import React from 'react';

const LaunchSection = () => {
  return (
    <section className="launch-section" id="launch">
      <div className="launch-inner">
        <p className="section-eyebrow">Launch Dates</p>
        <h2 className="section-title">Two dates. <em>One complete platform.</em></h2>
        <p className="section-intro">The best time to prepare for your exit was two years ago. The second-best time is April 16th.</p>
        <div className="launch-grid">
          <div className="launch-card mc">
            <p className="lc-eyebrow">🗓 Module 1 · Live Now</p>
            <p className="lc-date">16 April 2025</p>
            <h3 className="lc-title">The ValueARC M&A Masterclass</h3>
            <p className="lc-desc">Three hours of practical, founder-specific M&A preparation — every concept, every term, every framework you need before a buyer ever calls. The knowledge foundation for everything that follows.</p>
            <ul className="lc-includes">
              <li>Full 3-hour masterclass — 4 sections, 130+ slides</li>
              <li>M&A Fundamentals, Buyer Landscape, Data Room, QoE</li>
              <li>The 10 Value Maximizers — complete assessment framework</li>
              <li>M&A Sale Process, Deal Structure &amp; Closing</li>
              <li>Downloadable frameworks, checklists &amp; action templates</li>
              <li>Lifetime access — revisit any section at any time</li>
            </ul>
            <div className="lc-note">Enroll now and build your foundation ahead of the platform opening on 18 June 2026.</div>
          </div>
          <div className="launch-card pf">
            <p className="lc-eyebrow">🗓 Modules 2 &amp; 3 · Coming 18 June 2026</p>
            <p className="lc-date">18 June 2026</p>
            <h3 className="lc-title">Value Maximizer Dashboard &amp; Intelligent VDR</h3>
            <p className="lc-desc">Modules 2 and 3 launch on 18 June 2026 — the live valuation dashboard and the intelligent data room that turn your masterclass learning into measurable, buyer-ready preparation. Modules 4 and 5 dates will be announced shortly.</p>
            <ul className="lc-includes">
              <li>Module 2 — Value Maximizer Dashboard with live readiness tracking</li>
              <li>Module 3 — Intelligent VDR with real-time gap detection</li>
              <li>Module 4 — Go to Market · <strong>Launch date to be announced</strong></li>
              <li>Module 5 — Buyer Management &amp; Outreach · <strong>Launch date to be announced</strong></li>
              <li>Subscribe to any module independently at any time</li>
            </ul>
            <div className="lc-note">Subscribe to any individual module — or build the full platform as each launches. ValueARC meets you where you are.</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LaunchSection;
